import { RootState } from "@/app/stores"
import { getInvitations, IInvitation } from "@/shared/api/invitations"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchUsersInvitations = createAsyncThunk<
    IInvitation[],
    void,
    { state: RootState }
>('invitations/fetchUsersInvitations', async (_, thunkAPI) => {
    try {
        const data = await getInvitations("users")
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchInvitations = createAsyncThunk<
    IInvitation[],
    void,
    { state: RootState }
>('invitations/fetchInvitations', async (_, thunkAPI) => {
    try {
        const data = await getInvitations()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchEmployeesInvitations = createAsyncThunk<
    IInvitation[],
    void,
    { state: RootState }
>('invitations/fetchEmployeesInvitations', async (_, thunkAPI) => {
    try {
        const data = await getInvitations("employees")
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})